import { PopupCloseCallback, PopupOpenCallback, PopupProperties } from "../models/popup.models";
import * as FormsUtility from "./forms.utility";
import { UrlUtility } from "./url.utility";

export class PopupUtility {

    private static DEFAULT_WINDOW: string = "GenericWindow";

    public static createPopup(properties: PopupProperties) {
        let propertiesWithDefaults = Object.assign(new PopupProperties(), properties);
        let urlWithParams = UrlUtility.getUrlStringWithParams(propertiesWithDefaults.url, propertiesWithDefaults.params);

        window.ShowDialog(urlWithParams, null, propertiesWithDefaults.width, propertiesWithDefaults.height, propertiesWithDefaults.title, null, "E", null, propertiesWithDefaults.windowName, true, false, propertiesWithDefaults.callback ? (sender, args) => propertiesWithDefaults.callback(sender, args) : null);
    }

    public static closePopupOnFormSubmissionSuccess(value: any = true) {
        if (FormsUtility.isFormSubmissionSuccess()) {
            let currentWindow = window.GetRadWindow();
            currentWindow.close(value);
        }
    }

    public static getPopupWindowByName(windowName: string): Telerik.Web.UI.RadWindow {
        return window.GetRadWindowManager().getWindowByName(windowName);
    }

    public static addPopupWindowFrameLoad(callback: (sender: Telerik.Web.UI.RadWindow, iframe: HTMLIFrameElement) => void, popupWindowName: string = this.DEFAULT_WINDOW): PopupOpenCallback {
        let window = this.getPopupWindowByName(popupWindowName);

        let iFrameLoadCallback;
        let closeCallback: PopupCloseCallback = (sender, eventArgs) => {
            let jIframe = jQuery(sender.get_contentFrame());
            jIframe.off("load", iFrameLoadCallback);

            window.remove_close(closeCallback);
        };
        let showCallback: PopupOpenCallback = (sender, eventArgs) => {
            let jIframe = jQuery(sender.get_contentFrame());

            if (iFrameLoadCallback == null) {
                iFrameLoadCallback = function () {
                    callback(sender, this);
                    window.add_close(closeCallback);
                };
            }

            jIframe.off("load", iFrameLoadCallback).on("load", iFrameLoadCallback);
        };
        window.add_show(showCallback);

        return showCallback;
    }

    public static removePopupWindowFrameLoad(showCallback: PopupOpenCallback, popupWindowName: string = this.DEFAULT_WINDOW) {
        this.getPopupWindowByName(popupWindowName).remove_show(showCallback);
    }
}